// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { syscoin as _syscoin } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the syscoin chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 57
 * Chain Name: Syscoin Mainnet
 * Default Block Explorer: https://explorer.syscoin.org
 * Default RPC URL: https://rpc.syscoin.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { syscoin } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: syscoin,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const syscoin = createCommon({
	..._syscoin,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
